import { render, staticRenderFns } from "./TutorialTheory.vue?vue&type=template&id=808e20da&scoped=true&"
import script from "./TutorialTheory.vue?vue&type=script&lang=js&"
export * from "./TutorialTheory.vue?vue&type=script&lang=js&"
import style0 from "./TutorialTheory.vue?vue&type=style&index=0&id=808e20da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e20da",
  null
  
)

export default component.exports